module.exports = __webpack_public_path__ + "img/co-workers-reviewing-reports-1.408a1e7f.png";